import { render, staticRenderFns } from "./gamePopup.vue?vue&type=template&id=0f4908a2&scoped=true"
import script from "./gamePopup.vue?vue&type=script&lang=js"
export * from "./gamePopup.vue?vue&type=script&lang=js"
import style0 from "./gamePopup.vue?vue&type=style&index=0&id=0f4908a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4908a2",
  null
  
)

export default component.exports